const apiUrl = path => `${process.env.REACT_APP_API_URL || ''}/api/v1${path}`;

const IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

const isImage = contentType =>
  IMAGE_CONTENT_TYPES.includes(
    String(contentType || '')
      .split(';')[0]
      .trim()
      .toLowerCase(),
  );

export const fundingDocumentFileUrl = (folderId, document, file) => {
  if (
    !isImage(file?.fileContentType) ||
    !folderId ||
    !document?.id ||
    !file?.sharepointPath ||
    !file?.fileSha256
  ) {
    return file?.fileDownloadLink || null;
  }

  return apiUrl(
    `/folders/${folderId}/funding_documents/${document.id}/file?sha256=${encodeURIComponent(
      file.fileSha256,
    )}`,
  );
};

export const companyDocumentFileUrl = (companiesQuoteGroupId, document) => {
  if (
    !isImage(document?.fileContentType) ||
    !companiesQuoteGroupId ||
    !document?.id ||
    !(document.sharepointFilename || document.fileDownloadLink)
  ) {
    return document?.fileDownloadLink || null;
  }

  return apiUrl(`/companies_quote_groups/${companiesQuoteGroupId}/documents/${document.id}/file`);
};

export const companyLegalDocumentUrl = (companyId, documentType, downloadLink, contentType) =>
  companyId && downloadLink && isImage(contentType)
    ? apiUrl(`/companies/${companyId}/legal_document?document_type=${documentType}`)
    : downloadLink || null;
